export class TableLiveView {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "asOf",
            "baseName": "asOf",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "pipelineStatus",
            "baseName": "pipelineStatus",
            "type": "IngestionPipelineStatus",
            "format": ""
        },
        {
            "name": "recordCount",
            "baseName": "recordCount",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "lagSeconds",
            "baseName": "lagSeconds",
            "type": "number",
            "format": ""
        },
        {
            "name": "commitAgeSeconds",
            "baseName": "commitAgeSeconds",
            "type": "number",
            "format": ""
        },
        {
            "name": "primaryKey",
            "baseName": "primaryKey",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "clusterColumns",
            "baseName": "clusterColumns",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "columns",
            "baseName": "columns",
            "type": "Array<TableColumnStats>",
            "format": ""
        },
        {
            "name": "columnsOmitted",
            "baseName": "columnsOmitted",
            "type": "number",
            "format": ""
        },
        {
            "name": "signals",
            "baseName": "signals",
            "type": "Array<TableSignal>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return TableLiveView.attributeTypeMap;
    }
    constructor() {
    }
}
